import { useSignups } from "Signups/state";

export function useGetSignupListType() {
  const [state] = useSignups();
  const { signupListTypeID } = state.currentSignupList;

  return {
    isPollType: signupListTypeID === 4,
    isItemType: signupListTypeID === 5,
    isMemberType: signupListTypeID !== 4 && signupListTypeID !== 5,
  };
}
